import React, { useState } from "react";
import axios from "axios";
import imageCompression from "browser-image-compression";
import * as pdfjsLib from "pdfjs-dist/webpack";
import { jsPDF } from "jspdf";
import LoadingAnimation from "../LoadingAnimation";

const SendAgreement = ({
  itemId,
  isModalOpen,
  setIsModalOpen,
  isPhysicalAgreement,
  isCustomerDocument,
  customer_id,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [natureOfBusiness, setNatureOfBusiness] = useState("");
  const [signatoryDesignation, setSignatoryDesignation] = useState("");
  const [signType, setSignType] = useState("electronic");
  const [agreementType, setAgreementType] = useState("withoutEStamp"); // Dropdown for agreement type
  const [file, setFile] = useState(null);
  const [attachmentPreview, setAttachmentPreview] = useState(null); // For image preview
  const [customerDocument, setCustomerDocument] = useState([]);
  const [customerDocumentPreview, setCustomerDocumentPreview] = useState([]); // For image preview

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleFileUpload = async (event) => {
    let file = event.target.files[0];
    if (!file) return;

    if (file.type.startsWith("image/")) {
      file = await compressImage(file);
    } else if (file.type === "application/pdf") {
      file = await compressPdf(file);
    }

    setFile(file);
    const reader = new FileReader();
    reader.onload = (e) => setAttachmentPreview(e.target.result);
    reader.readAsDataURL(file);
  };
  const removeAttachment = () => {
    setFile(null);
    setAttachmentPreview(null);
  };

  const uploadFile = async () => {
    if (!file) {
      alert("Please upload a file.");
      return;
    }
    setIsLoading(true);
    const formData = new FormData();
    formData.append("file", file);
    formData.append("preOrderId", itemId._id);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_MYBACKEND_PI}/api/generatePI/uploadAgreement`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      alert(response.data.message);
      closeModal();
    } catch (error) {
      alert("File upload failed. Please try again." + error);
    } finally {
      setIsLoading(false);
    }
  };

  const uploadCustomerDocument = async () => {
    if (!customerDocument) {
      alert("Please upload a file.");
      return;
    }
    setIsLoading(true);
    const formData = new FormData();

    customerDocument.forEach((file, index) => {
      formData.append(`file${index + 1}`, file);
    });
    formData.append("preOrderId", itemId._id);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_MYBACKEND_PI}/api/generatePI/uploadCustomerDocument`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      alert(response.data.message);
      closeModal();
    } catch (error) {
      alert("File upload failed. Please try again." + error);
      closeModal();
    } finally {
      setIsLoading(false);
    }
  };
  const compressImage = async (file) => {
    const options = {
      maxSizeMB: 0.5, // Limit size to 0.5MB
      maxWidthOrHeight: 800,
      useWebWorker: true,
    };
    return await imageCompression(file, options);
  };

  const compressPdf = async (file) => {
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);

    return new Promise((resolve, reject) => {
      reader.onload = async () => {
        try {
          const pdfBytes = new Uint8Array(reader.result);
          const pdf = await pdfjsLib.getDocument({ data: pdfBytes }).promise; // Load PDF
          const newPdf = new jsPDF();

          for (let i = 0; i < pdf.numPages; i++) {
            const page = await pdf.getPage(i + 1);
            const viewport = page.getViewport({ scale: 1.5 });

            // Create canvas
            const canvas = document.createElement("canvas");
            canvas.width = viewport.width;
            canvas.height = viewport.height;
            const ctx = canvas.getContext("2d");

            // Render PDF page to canvas
            await page.render({ canvasContext: ctx, viewport }).promise;

            // Convert canvas to JPEG with compression
            const imgData = canvas.toDataURL("image/jpeg", 0.5);

            if (i > 0) newPdf.addPage();
            newPdf.addImage(imgData, "JPEG", 5, 5, 200, 280);
          }

          // Convert new PDF to Blob
          const compressedPdfBlob = new Blob([newPdf.output("blob")], {
            type: "application/pdf",
          });
          resolve(
            new File([compressedPdfBlob], file.name, {
              type: "application/pdf",
            })
          );
        } catch (error) {
          console.error("PDF compression failed:", error);
          reject(error);
        }
      };
    });
  };

  const handleCustomerDocumentUpload = async (event) => {
    const selectedFiles = Array.from(event.target.files);

    if (customerDocument.length + selectedFiles.length > 10) {
      alert("You can upload a maximum of 10 files.");
      return;
    }

    const compressedFiles = await Promise.all(
      selectedFiles.map(async (file) => {
        if (file.type.startsWith("image/")) {
          return await compressImage(file);
        } else if (file.type === "application/pdf") {
          return await compressPdf(file);
        }
        return file;
      })
    );

    setCustomerDocument([...customerDocument, ...compressedFiles]);

    const newPreviews = compressedFiles.map((file) => {
      if (file.type.startsWith("image/") || file.type === "application/pdf") {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        return new Promise((resolve) => {
          reader.onload = (e) => resolve(e.target.result);
        });
      }
      return null;
    });
    Promise.all(newPreviews).then((previews) => {
      setCustomerDocumentPreview([...customerDocumentPreview, ...previews]);
    });
  };

  const removeCustomerDocumentAttachment = (index) => {
    setCustomerDocument(customerDocument.filter((_, i) => i !== index));
    setCustomerDocumentPreview(
      customerDocumentPreview.filter((_, i) => i !== index)
    );
  };

  const sendAgreement = async () => {
    setIsLoading(true);
    try {
      alert(
        `Sending ${
          agreementType === "withEStamp" ? "with E-Stamp" : "without E-Stamp"
        }`
      );
      console.log("start");
      const preOrderResponse = await axios.get(
        `${process.env.REACT_APP_MYBACKEND_PI}/api/preOrder/${itemId._id}`
      );
      const preOrder = preOrderResponse.data;
      console.log({ preOrder });
      if (!preOrder.customer) {
        throw new Error("Customer data is missing in the preOrder response.");
      }
      const feesTable = preOrder?.AcDetails?.map((acDetail, index) => ({
        no: (index + 1).toString(),
        // Month: acDetail?.subscription_price.toString(),
        Monthly3Years: acDetail?.subscription_price.toString(),
        Monthly2Years: (
          acDetail?.fixedPriceAfter3Years || acDetail?.subscription_price
        ).toString(),
        deposit: acDetail?.deposit?.toString(),
        fee: acDetail?.installation_price.toString(),
        ton:
          acDetail?.model === "S10"
            ? "1"
            : acDetail?.model === "S20"
            ? "2"
            : acDetail?.model === "S15"
            ? "1.5"
            : acDetail?.model === "C20"
            ? "2"
            : acDetail.model === "C30"
            ? "3"
            : "",
        qun: acDetail?.quantity?.toString(),
        type: acDetail?.ac_type,
        term: acDetail?.plan_year.toString(),
      }));
      const delhiFeesTable = preOrder?.AcDetails?.map((acDetail, index) => ({
        no: (index + 1).toString(),
        // Month: acDetail?.subscription_price.toString(),
        Monthly3Years1: acDetail?.subscription_price.toString(),
        Monthly3Years2: (
          acDetail?.fixedPriceAfter3Years || acDetail?.subscription_price
        ).toString(),
        deposit: acDetail?.deposit?.toString(),
        fee: acDetail?.installation_price.toString(),
        ton:
          acDetail?.model === "S10"
            ? "1"
            : acDetail?.model === "S20"
            ? "2"
            : acDetail?.model === "S15"
            ? "1.5"
            : acDetail?.model === "C20"
            ? "2"
            : acDetail.model === "C30"
            ? "3"
            : "",
        qun: acDetail?.quantity?.toString(),
        type: acDetail?.ac_type,
        term: acDetail?.plan_year.toString(),
      }));
      console.log({ feesTable });

      const subscriptionTerm = preOrder?.AcDetails[0]?.plan_year;
      const getShippingAddress =
        preOrder?.customer_shipping_address?.address_line1 +
        ", " +
        preOrder?.customer_shipping_address?.address_line2 +
        ", " +
        preOrder?.customer_shipping_address?.city +
        ", " +
        preOrder?.customer_shipping_address?.country +
        ", " +
        preOrder?.customer_shipping_address?.state;
      const requestBody = {
        signers: [
          {
            identifier: preOrder?.customer?.email,
            name: preOrder?.customer?.name,
            sign_type: signType,
          },
        ],
        expire_in_days: 40,
        generate_access_token: true,
        display_on_page: "custom",
        send_sign_link: true,
        notify_signers: true,
        file_name: `${preOrder?.customer?.name}-${new Date().getTime()}`,
        ...(agreementType === "withEStamp" && {
          estamp_request: {
            tags: {
              "MH-100-CL_Stamp2": "1",
            },
          },
        }),
        templates: [
          {
            template_key: process.env.REACT_APP_DIGIO_STATIC_FORM_KEY,
            template_values: {
              "Signatory Name": preOrder?.brandName || "Admin",
              "Execution Date": new Date().toISOString().split("T")[0],
              "Nature of Business ": natureOfBusiness || "",
              "Signatory Designation": signatoryDesignation || "",
              "Subscripition Term": subscriptionTerm,
              "Company Name ": preOrder?.superAdmin || "Your Company",
              "Customer Name": preOrder?.superAdmin,
              "Shipping Address": getShippingAddress || "",
            },
          },
          {
            template_key:
              preOrder?.AcDetails[0]?.plan_year === "3+3year"
                ? process.env.REACT_APP_DIGIO_DYNAMIC_FORM_KEY_DELHI
                : process.env.REACT_APP_DIGIO_DYNAMIC_FORM_KEY,
            template_table_values: {
              fees:
                preOrder?.AcDetails[0]?.plan_year === "3+3year"
                  ? delhiFeesTable
                  : feesTable,
            },
          },
        ],
      };
      console.log({ requestBody });

      const response = await axios.post(
        `${process.env.REACT_APP_MYBACKEND_PI}/api/preOrder/send-agreement`,
        requestBody,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const fileName = response.data.file_name;
      if (fileName) {
        await axios.put(
          `${process.env.REACT_APP_MYBACKEND_PI}/api/preOrder/saveAgreementId/${itemId._id}`,
          { pdfId: fileName },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        const acQuantities = preOrder.AcDetails.reduce(
          (acc, ac) => {
            switch (ac.model) {
              case "S10":
                acc.split1Ton += ac.quantity || 0;
                break;
              case "S20":
                acc.split2Ton += ac.quantity || 0;
                break;
              case "S15":
                acc.split1_5Ton += ac.quantity || 0;
                break;
              case "C20":
                acc.cassette2Ton += ac.quantity || 0;
                break;
              case "C30":
                acc.cassette3Ton += ac.quantity || 0;
                break;
            }
            return acc;
          },
          {
            split1Ton: 0,
            split2Ton: 0,
            split1_5Ton: 0,
            cassette2Ton: 0,
            cassette3Ton: 0,
          }
        );
        const customer_details = {
          customerName: preOrder.customer.name,
          customermobile: preOrder.customer.mobile,
          customer_id: preOrder.customer.customer_id,
          preOrdertimestamp: preOrder.preOrdertimestamp,
          contactPerson: preOrder.customer_shipping_address.contactPerson,
          contactNumber: preOrder.customer_shipping_address.contactNumber,
          shippingAddress: `${preOrder.customer_shipping_address.address_line1}, ${preOrder.customer_shipping_address.address_line2}`,
          pincode: preOrder.customer_shipping_address.pincode,
          ...acQuantities,
          pdfId: fileName,
        };
        await axios.post(
          `${process.env.REACT_APP_MYBACKEND_PI}/api/google-sheets/agreement`,
          { customer_details },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            },
          }
        );
        alert(
          "Agreement ID saved and data sent to Google Sheets successfully!"
        );
      }
    } catch (error) {
      alert("Failed to send agreement. Please try again.");
      console.log("error ", error.message);
    } finally {
      setIsLoading(false);
      closeModal();
    }
  };

  return isModalOpen ? (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-md mx-4 p-6 relative">
        {/* Close Button */}
        <button
          onClick={closeModal}
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-800 text-xl"
        >
          &times;
        </button>
        <h3 className="text-lg font-semibold mb-4">
          {isPhysicalAgreement
            ? "Upload Agreement File"
            : isCustomerDocument
            ? "Upload Customer Documents"
            : "Send Agreement"}
        </h3>
        {isPhysicalAgreement && itemId?.isAgreementSigned === false ? (
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">
              Upload Agreement File
            </label>
            <input
              type="file"
              onChange={handleFileUpload}
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm"
            />
            {file && (
              <div className="mt-2">
                <div className="flex items-center space-x-2">
                  <span className="text-sm text-gray-600">{file.name}</span>
                  <button
                    onClick={removeAttachment}
                    className="text-red-500 hover:underline text-sm"
                  >
                    Delete
                  </button>
                </div>
                {attachmentPreview && (
                  <div className="mt-2">
                    {file.type === "application/pdf" ? (
                      <iframe
                        src={attachmentPreview}
                        width="100%"
                        height="500px"
                      ></iframe>
                    ) : (
                      <img
                        src={attachmentPreview}
                        alt="Preview"
                        width="w-48 h-32 object-cover rounded border border-gray-300"
                      />
                    )}
                    {/* <img
                      src={attachmentPreview}
                      alt="Preview"
                      className="w-48 h-32 object-cover rounded border border-gray-300"
                    /> */}
                  </div>
                )}
              </div>
            )}
          </div>
        ) : isPhysicalAgreement && itemId?.isAgreementSigned === true ? (
          <div className="mb-4 text-green-700 text-center border border-green-400 rounded-md p-4 bg-green-50">
            ✅ This customer's agreement is already verified and signed.
            <br />
            Please contact admin for further actions.
          </div>
        ) : isCustomerDocument && itemId?.isDocumentApprove === false ? (
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">
              "Upload Customer Documents (Max: 10)"
            </label>
            <input
              type="file"
              onChange={handleCustomerDocumentUpload}
              multiple={isCustomerDocument}
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm"
            />

            {/* Uploaded Files List */}
            {customerDocument?.length > 0 && (
              <div className="mt-2">
                {customerDocument.map((file, index) => (
                  <div key={index} className="flex items-center space-x-2">
                    <span className="text-sm text-gray-600">{file.name}</span>
                    <button
                      onClick={() => removeCustomerDocumentAttachment(index)}
                      className="text-red-500 hover:underline text-sm"
                    >
                      Delete
                    </button>
                  </div>
                ))}
                {/* Image Previews */}
                <div className="flex flex-col gap-2 mt-2 max-h-[400px] overflow-y-auto">
                  {customerDocumentPreview.map(
                    (preview, index) =>
                      preview &&
                      customerDocument[index].type === "application/pdf" ? (
                        <iframe
                          key={index}
                          src={preview}
                          className="w-[60%] h-[300px] border border-gray-300 rounded"
                        ></iframe>
                      ) : (
                        <img
                          src={preview}
                          alt="Preview"
                          width="w-48 h-32 object-cover rounded border border-gray-300"
                        />
                      )
                    // <img
                    //   key={index}
                    //   src={preview}
                    //   alt="Preview"
                    //   className="w-16 h-16 object-cover rounded border border-gray-300"
                    // />
                  )}
                </div>
              </div>
            )}
          </div>
        ) : isCustomerDocument && itemId?.isDocumentApprove === true ? (
          <div className="mb-4 text-green-700 text-center border border-green-400 rounded-md p-4 bg-green-50">
            ✅ Customer documents are already verified.
            <br />
            You cannot upload new documents.
          </div>
        ) : (
          <>
            {/* Nature of Business Dropdown */}
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700">
                Nature of Business
              </label>
              <select
                value={natureOfBusiness}
                onChange={(e) => setNatureOfBusiness(e.target.value)}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm"
              >
                <option value="" disabled>
                  Select Nature of Business
                </option>
                <option value="Cafe/Resto Bar">Cafe/Resto Bar</option>
                <option value="Pg/Co-living/Hostel">Pg/Co-living/Hostel</option>
                <option value="Hotel">Hotel</option>
                <option value="Gym">Gym</option>
                <option value="Office Space">Office Space</option>
                <option value="Independent Shop">Independent Shop</option>
                <option value="Residential">Residential</option>
                <option value="Spa">Spa</option>
                <option value="Salon">Salon</option>
                <option value="Pharmacies">Pharmacies</option>
                <option value="Factory">Factory</option>
                <option value="Clinic">Clinic</option>
                <option value="Retail Supermarket">Retail Supermarket</option>
                <option value="Laundry">Laundry</option>
                <option value="Coaching Centre">Coaching Centre</option>
                <option value="Banquet">Banquet</option>
                <option value="School">School</option>
                <option value="College">College</option>
              </select>
            </div>

            {/* Signatory Designation */}
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700">
                Signatory Designation
              </label>
              <input
                type="text"
                value={signatoryDesignation}
                onChange={(e) => setSignatoryDesignation(e.target.value)}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm"
                placeholder="Enter Signatory Designation"
              />
            </div>

            {/* Signature Type Dropdown */}
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700">
                Signature Type
              </label>
              <select
                value={signType}
                onChange={(e) => setSignType(e.target.value)}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm"
              >
                <option value="electronic">Electronic</option>
                <option value="aadhaar">Aadhaar</option>
              </select>
            </div>

            {/* Agreement Type Dropdown */}
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700">
                Agreement Type
              </label>
              <select
                value={agreementType}
                onChange={(e) => setAgreementType(e.target.value)}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm"
              >
                <option value="withoutEStamp">Without E-Stamp</option>
                <option value="withEStamp">With E-Stamp</option>
              </select>
            </div>
          </>
        )}
        {isLoading && (
          <div className="fixed inset-0 bg-gray-50 bg-opacity-70 overflow-y-auto h-full w-full flex items-center justify-center">
            <LoadingAnimation />
          </div>
        )}

        {/* Send Button */}
        {/* <button
          onClick={sendAgreement}
          className="w-full px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-600"
          disabled={isLoading}
        >
          {isLoading ? "Sending..." : "Send Agreement"}
        </button> */}
        <button
          onClick={
            isPhysicalAgreement
              ? uploadFile
              : isCustomerDocument
              ? uploadCustomerDocument
              : sendAgreement
          }
          className={`w-full px-4 py-2 rounded-md ${
            (isPhysicalAgreement && !file) ||
            (isCustomerDocument && customerDocument.length === 0)
              ? "bg-gray-400"
              : "bg-green-500 hover:bg-green-600"
          } text-white`}
          disabled={
            isLoading ||
            (isPhysicalAgreement && !file) ||
            (isCustomerDocument && customerDocument.length === 0)
          }
        >
          {isLoading
            ? "Processing..."
            : isPhysicalAgreement || isCustomerDocument
            ? "Upload File"
            : "Send Agreement"}
        </button>
      </div>
    </div>
  ) : null;
};

export default SendAgreement;
